/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { getReactField, getId } from '../helpers/react-form-helpers';
import { useForm, Controller } from 'react-hook-form';
import { Button, Checkbox, FormHelperText } from '@material-ui/core';
import { geocodeByAddress } from 'react-places-autocomplete';
import { ReCaptcha } from './CaptchaButton';

export const ReactForm = ({ jsonData, reCaptchaKey }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [googleAddress, setGoogleAddress] = useState();
  const [zipLabel, setZipLabel] = useState(jsonData.zipField);
  const [zipRegEx, setZipRegEx] = useState();
  const [zipFormat, setZipFormat] = useState();
  const [streetNumberLast, setStreetNumberLast] = useState(false);
  const [countryCode, setCountryCode] = useState();
  const [examplePhone, setExamplePhone] = useState();
  const [useFormattedAddressField, setUseFormattedAddressField] =
    useState(false);
  const [disableGoogleLookup, setDisableGoogleLookup] = useState(false);
  const [refreshReCaptcha] = useState(false);
  const [stateRequired, setStateRequired] = useState(true);
  const [zipRequired, setZipRequired] = useState(true);

  const handleChange = (address) => {
    setGoogleAddress(address);
  };

  useEffect(() => {}, showConfirmation);

  function getInitialState(data) {
    const fields = { chkConfirmations: false };
    data.sections?.map((section) => {
      section.fields?.map((field) => {
        fields[getId(field.label)] = '';
      });
    });

    return fields;
  }

  const {
    handleSubmit,
    control,
    getValues,
    watch,
    setValue,
    setError,
    clearErrors,
    resetField,
    register,
  } = useForm({
    defaultValues: getInitialState(jsonData),
    mode: 'onBlur',
  });

  useEffect(() => {
    if (
      jsonData.reCaptchaEnabled &&
      typeof reCaptchaKey !== 'undefined' &&
      reCaptchaKey !== null &&
      reCaptchaKey !== ''
    ) {
      register('captchaToken', { required: true });
    }
  });

  const onVerifyCaptcha = (token) => {
    setValue('captchaToken', token);
  };

  const handleSelect = (address) => {
    geocodeByAddress(address).then((results) => {
      const addressResults = {
        number: '',
        route: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        formattedAddress: '',
      };
      if (results.length > 0 && results[0].address_components.length > 0) {
        addressResults.formattedAddress = results[0].formatted_address;
        for (let i = 0; i < results[0].address_components.length; ++i) {
          if (
            results[0].address_components[i].types &&
            results[0].address_components[i].types[0] === 'street_address'
          ) {
            addressResults.route = results[0].address_components[i].short_name;
          }
          if (
            addressResults.route === '' &&
            results[0].address_components[i].types &&
            results[0].address_components[i].types[0] === 'street_number'
          ) {
            addressResults.number = results[0].address_components[i].short_name;
          }
          if (
            results[0].address_components[i].types &&
            results[0].address_components[i].types[0] === 'route'
          ) {
            addressResults.route = results[0].address_components[i].long_name;
          }
          if (
            addressResults.route === '' &&
            addressResults.number === '' &&
            results[0].address_components[i].types &&
            typeof results[0].address_components[i].types.find((type) => {
              return type === 'sublocality_level_1';
            }) !== 'undefined'
          ) {
            addressResults.route = results[0].address_components[i].long_name;
            addressResults.number = '';
          } else if (
            results[0].address_components[i].types &&
            typeof results[0].address_components[i].types.find((type) => {
              return type === 'sublocality_level_1';
            }) !== 'undefined'
          ) {
            addressResults.state = results[0].address_components[i].long_name;
          }

          if (
            results[0].address_components[i].types &&
            results[0].address_components[i].types[0] === 'route_two'
          ) {
            addressResults.address2 =
              results[0].address_components[i].long_name;
          }
          if (
            results[0].address_components[i].types &&
            (results[0].address_components[i].types[0] === 'locality' ||
              results[0].address_components[i].types[0] === 'postal_town' ||
              results[0].address_components[i].types[0] === 'neigborhood')
          ) {
            addressResults.city = results[0].address_components[i].long_name;
          }
          if (
            results[0].address_components[i].types &&
            results[0].address_components[i].types[0] ===
              'administrative_area_level_1'
          ) {
            addressResults.state = results[0].address_components[i].long_name;
          }
          if (
            results[0].address_components[i].types &&
            results[0].address_components[i].types[0] === 'postal_code'
          ) {
            addressResults.zip = results[0].address_components[i].long_name;
          }

          if (
            results[0].address_components[i].types &&
            results[0].address_components[i].types[0] === 'country'
          ) {
            addressResults.country =
              results[0].address_components[i].short_name;
          }
        }

        resetField(getId(jsonData.address1Field));
        resetField(getId(jsonData.address2Field));
        resetField(getId(jsonData.cityField));
        resetField(getId(jsonData.stateField));
        resetField(getId(jsonData.zipField));
        resetField(getId(jsonData.fullAddressField));

        setValue(
          getId(jsonData.fullAddressField),
          addressResults.formattedAddress
        );

        if (useFormattedAddressField === false) {
          if (
            jsonData.address1Field &&
            jsonData.address1Field !== null &&
            jsonData.address1Field !== ''
          ) {
            if (streetNumberLast) {
              setValue(
                getId(jsonData.address1Field),
                `${addressResults.route} ${addressResults.number}`.trim()
              );
              setGoogleAddress(
                `${addressResults.route} ${addressResults.number}`.trim()
              );
            } else {
              setValue(
                getId(jsonData.address1Field),
                `${addressResults.number} ${addressResults.route}`.trim()
              );
              setGoogleAddress(
                `${addressResults.number} ${addressResults.route}`.trim()
              );
            }

            clearErrors(getId(jsonData.address1Field));
          }
          if (
            jsonData.address2Field &&
            jsonData.address2Field !== null &&
            jsonData.address2Field !== ''
          ) {
            setValue(
              getId(jsonData.address2Field),
              `${addressResults.address2}`
            );
            clearErrors(getId(jsonData.address2Field));
          }

          if (
            jsonData.cityField &&
            jsonData.cityField !== null &&
            jsonData.cityField !== ''
          ) {
            setValue(getId(jsonData.cityField), `${addressResults.city}`);
            clearErrors(getId(jsonData.cityField));
          }
          if (
            jsonData.stateField &&
            jsonData.stateField !== null &&
            jsonData.stateField !== ''
          ) {
            setValue(getId(jsonData.stateField), `${addressResults.state}`);
            clearErrors(getId(jsonData.stateField));
          }
          if (
            jsonData.zipField &&
            jsonData.zipField !== null &&
            jsonData.zipField !== ''
          ) {
            setValue(getId(jsonData.zipField), `${addressResults.zip}`);
            clearErrors(getId(jsonData.zipField));
          }
        } else {
          setGoogleAddress('');
          setValue(
            getId(jsonData.address1Field),
            addressResults.formattedAddress
          );
        }
      }
    });
  };

  const autocompletionRequestJson =
    countryCode !== null && countryCode !== ''
      ? {
          componentRestrictions: { country: [countryCode] },
        }
      : {
          componentRestrictions: {},
        };

  function switchDisplay(controlledBy, method) {
    const controlValue = getValues(getId(controlledBy));
    switch (method) {
      case 'otherContactReason':
        return controlValue !== 'RequestSample';
      case 'requestContactReason':
        return controlValue === 'RequestSample';
      default:
        console.log(`React Method ${method} unhandled`);
        return true;
    }
  }

  function sectionChange(section) {
    if (
      typeof section.controlledBy !== 'undefined' &&
      typeof section.method !== 'undefined' &&
      section.controlledBy !== null &&
      section.method !== null &&
      section.controlledBy !== '' &&
      section.method !== ''
    ) {
      return switchDisplay(section.controlledBy, section.method);
    }

    return true;
  }

  function fieldChange(field) {
    if (
      typeof field.controlledBy !== 'undefined' &&
      typeof field.method !== 'undefined' &&
      field.controlledBy !== null &&
      field.method !== null &&
      field.controlledBy !== '' &&
      field.method !== ''
    ) {
      return switchDisplay(field.controlledBy, field.method);
    }
    return true;
  }

  const scroll = () => {
    const section = document.querySelector('#react-form-root');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const onSubmit = async (data) => {
    clearErrors('captchaToken');
    await fetch('/corbapi/reactforms/verifyrecaptcha', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        token: getValues('captchaToken'),
      }),
    })
      .then((res) => {
        if (res.ok === true && res.status === 200) {
          setShowConfirmation(true);
          scroll();
        } else {
          setValue('captchaToken', '');
          setError('captchaToken', {
            type: 'custom',
            message: jsonData.reCaptchaErrorMessage,
          });
        }
      })
      .catch((e) => {
        setValue('captchaToken', '');
        setError('captchaToken', {
          type: 'custom',
          message: e.message,
        });
      });
  };

  return (
    <div className="form-body">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className={`inner-container ${
            showConfirmation ? 'confirmation' : ''
          }`}
        >
          {showConfirmation ? (
            <>
              <div className="confirmation-block">
                <div className="check">
                  <i className="fa fa-check-circle check-circle"></i>
                </div>
                <div className="header">
                  <h3>{jsonData.thankYouTextHeader}</h3>
                </div>
                <div className="body">
                  <p>{jsonData.thankYouTextBody}</p>
                </div>
              </div>
            </>
          ) : (
            <>
              {jsonData.sections
                .filter((section) => {
                  return sectionChange(section);
                })
                .map((section, i) => {
                  return (
                    <div key={i} className="section">
                      <div className="section-header">
                        <h3>{section.sectionTitle}</h3>
                      </div>
                      <div className="section-body">
                        {section.fields
                          .filter((field) => {
                            return fieldChange(field);
                          })
                          .map((field, ii) => {
                            return (
                              <>
                                {getReactField(
                                  field,
                                  jsonData,
                                  zipFormat,
                                  countryCode,
                                  control,
                                  googleAddress,
                                  handleChange,
                                  handleSelect,
                                  autocompletionRequestJson,
                                  watch,
                                  stateRequired,
                                  zipRequired,
                                  zipRegEx,
                                  zipLabel,
                                  (data) => {
                                    setCountryCode(data.code);
                                    setExamplePhone(data.examplePhone);
                                    setZipLabel(data.zipLabel);
                                    setDisableGoogleLookup(data.noGoogleLookup);
                                    setUseFormattedAddressField(
                                      data.useFormattedAddressField
                                    );
                                    setZipRegEx(
                                      data.zipRegEx.replaceAll(
                                        '[A-Z]',
                                        '[a-zA-Z]'
                                      )
                                    );
                                    setZipFormat(
                                      data.zipFormat
                                        .replaceAll('#', '9')
                                        .replaceAll('@', 'a')
                                    );
                                    setStreetNumberLast(data.streetNumberLast);
                                    setStateRequired(data.stateRequired);
                                    setZipRequired(data.zipRequired);
                                  },
                                  setGoogleAddress,
                                  resetField,
                                  examplePhone,
                                  disableGoogleLookup,
                                  useFormattedAddressField,
                                  ii
                                )}
                              </>
                            );
                          })}
                      </div>
                    </div>
                  );
                })}
            </>
          )}
        </div>
        {showConfirmation !== true && (
          <div className="footer-components">
            <div className="confirmations">
              <Controller
                name="chkConfirmations"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: jsonData.termsOfUseError,
                  },
                }}
                render={({
                  field: { onChange, value, ref },
                  fieldState: { error },
                }) => (
                  <>
                    <label htmlFor="chkConfirmations">
                      <>
                        <Checkbox
                          id="chkConfirmations"
                          onChange={onChange}
                          error={!!error}
                          value={value}
                          inputRef={ref}
                          size="small"
                          color="secondary"
                        ></Checkbox>

                        <p
                          className="confirmation-text"
                          dangerouslySetInnerHTML={{
                            __html: jsonData.termsOfUse,
                          }}
                        ></p>
                      </>
                    </label>
                    <FormHelperText
                      margin="dense"
                      className={`MuiFormHelperText-contained toc-error ${
                        error ? 'Mui-error' : ''
                      }`}
                    >
                      {error ? error.message : ''}
                    </FormHelperText>
                  </>
                )}
              />
            </div>
            {jsonData.reCaptchaEnabled &&
              typeof reCaptchaKey !== 'undefined' &&
              reCaptchaKey !== null &&
              reCaptchaKey !== '' && (
                <Controller
                  name="captchaToken"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                    },
                  }}
                  render={({
                    field: { onChange, value, ref },
                    fieldState: { error },
                  }) => (
                    <>
                      <ReCaptcha
                        onVerifyCaptcha={onVerifyCaptcha}
                        reCaptchaKey={reCaptchaKey}
                        refreshReCaptcha={refreshReCaptcha}
                        inputRef={ref}
                      />
                      <FormHelperText
                        margin="dense"
                        className={`MuiFormHelperText-contained toc-error ${
                          error ? 'Mui-error' : ''
                        }`}
                      >
                        {error ? error.message : ''}
                      </FormHelperText>
                    </>
                  )}
                />
              )}
            <div className="button-container">
              <Button
                type="submit"
                variant={'contained'}
                className="btn btn-conversion btn-form"
                size="small"
                data-title={
                  jsonData.submitGATaggingTitle &&
                  jsonData.submitGATaggingTitle !== null
                    ? jsonData.submitGATaggingTitle
                    : undefined
                }
                data-text={
                  jsonData.submitGATaggingText &&
                  jsonData.submitGATaggingText !== null
                    ? jsonData.submitGATaggingText
                    : undefined
                }
              >
                {jsonData.sendButtonText}
              </Button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};
